import React, { useEffect, useState } from "react";
import { CustomModal } from "../../components/styledComponent/styledModal";
import {
  StyledButton,
  StyledInput,
  StyledSelect,
} from "../../components/styledComponent/styledElements";
import { Col, Divider, Form, Row } from "antd";
import { listAllCategories } from "../../server/categoryServices";
import { useAppContext } from "../../contexts/appContext";

const CategoryCreationModal = ({
  showCreationModal = false,
  setShowCreationModal,
  onSubmit,
  onUpdate,
  formRef,
  update,
  setUpdate,
}) => {
  const { startLoading, stopLoading } = useAppContext();
  const [category, setCategory] = useState([]);
  const fetchCategories = async () => {
    try {
      startLoading();
      var categories = await listAllCategories();
      categories = categories?.data.map((val) => ({
        value: val.id,
        label: val.name,
      }));
      setCategory(categories);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      stopLoading();
    }
  };
  useEffect(() => {
    fetchCategories();
  }, []);

  const onSubmitForm = () => {
    formRef.current.submit();
  };
  const onCancelForm = () => {
    formRef.current.resetFields();
    setShowCreationModal(false);
    setUpdate(null);
  };

  return (
    <CustomModal
      title={update ? "Update Category" : "Add Category"}
      open={showCreationModal}
      onClose={onCancelForm}
      onCancel={onCancelForm}
      footer={[
        <StyledButton
          key="cancel"
          onClick={onCancelForm}
          background="white"
          color="black"
        >
          Cancel
        </StyledButton>,
        <StyledButton key={"submit"} onClick={onSubmitForm}>
          {update ? "Update" : "Create"}
        </StyledButton>,
      ]}
    >
      <Divider className="mt-0" />

      <Form
        ref={formRef}
        onFinish={update ? onUpdate : onSubmit}
        initialValues={update || {}}
        layout="vertical"
      >
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              label="Category Name"
              name="name"
              rules={[
                { required: true, message: "Please enter category name!" },
              ]}
            >
              <StyledInput width={"100%"} placeholder="Enter Category Name" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Category Name in Arabic" name="name_arabic">
              <StyledInput
                width={"100%"}
                placeholder="Enter Category Name in arabic"
                dir="rtl"
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="Parent Category" name="parent_id">
              <StyledSelect
                placeholder="Select parent Category"
                width={"100%"}
                options={category}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </CustomModal>
  );
};
export default CategoryCreationModal;
